import { render, staticRenderFns } from "./CharacteristicEffectButtons.vue?vue&type=template&id=126db1ec&"
import script from "./CharacteristicEffectButtons.vue?vue&type=script&lang=js&"
export * from "./CharacteristicEffectButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports